import { AppProvider } from '@!/providers'
import React, { Suspense, lazy } from 'react'
const HomePage = lazy(() => import('@!/Store/Home/containers/HomePage').then((module) => ({ default: module.HomePage })))
const StoreApp = React.lazy(() => import('@!/Store/Common/containers/StoreApp'))
import { useAppSettings } from '@!/Hooks/useAppSettings'

const HomeApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: true, alertMessage: props.alert_message })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <StoreApp {...props}>
          <HomePage home={props.home} genreTabName={props.genre_tab_name} />
        </StoreApp>
      </Suspense>
    </AppProvider>
  )
}

export default HomeApp
